const RelationshipQueryKeys = {
  global: ["relationships"] as const,

  /**
   * List
   */
  list: (ids: string[]) =>
    [...RelationshipQueryKeys.global, "list", ...ids] as const,

  /**
   * By Account
   */
  byAccount: (accountId: string) =>
    [...RelationshipQueryKeys.global, "account", accountId] as const,
};

export { RelationshipQueryKeys };
